import axios from "axios";
import { endpoints } from "../../endpoints";
import type {
  LeadFormOtpLeadType,
  LeadOtpInitResponse,
} from "../../types/types";

type InitOtpParams = {
  storefrontId: string;
  email: string;
  phone?: string;
  leadType: LeadFormOtpLeadType;
  sampleRequestId?: string;
};

export async function initLeadFormOtp({
  storefrontId,
  email,
  phone,
  leadType,
  sampleRequestId,
}: InitOtpParams): Promise<LeadOtpInitResponse> {
  const response = await axios.post<LeadOtpInitResponse>(
    endpoints.v1_storefronts_id_leads_otp_init(storefrontId),
    {
      email,
      phone,
      lead_type: leadType,
      sample_request_id: sampleRequestId,
    }
  );
  return response.data;
}

export async function resendLeadFormOtp(
  storefrontId: string,
  otpSessionId: string
): Promise<LeadOtpInitResponse> {
  const response = await axios.post<LeadOtpInitResponse>(
    endpoints.v1_storefronts_id_leads_otp_resend(storefrontId),
    { otp_session_id: otpSessionId }
  );
  return response.data;
}

export async function verifyAndSubmitLeadFormOtp(
  storefrontId: string,
  otpSessionId: string,
  code: string,
  formPayload: Record<string, unknown>
) {
  return axios.post(
    endpoints.v1_storefronts_id_leads_otp_verify_and_submit(storefrontId),
    {
      ...formPayload,
      otp_session_id: otpSessionId,
      code: code.trim(),
    }
  );
}
